export default class Files {
  static downloadContent(content, fileName = "") {
    const linkElement = window.document.createElement("a");

    linkElement.setAttribute("href", content);
    linkElement.setAttribute("download", fileName);
    linkElement.click();
  }

  static preloadImages(imagesUrls) {
    return Promise.all(imagesUrls.map((imageUrl) => {
      return new Promise((resolve, reject) => {
        const image = new Image();

        const handleLoadComplete = () => resolve(image);

        image.src = imageUrl;
        if (image.complete || image.readyState === XMLHttpRequest.DONE) handleLoadComplete();
        else {
          image.addEventListener("load", handleLoadComplete);
          image.addEventListener("error", () => reject());
        }
      });
    }));
  }
}
